import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IFormAlert {
  type: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message: string;
  isVisible: boolean;
}

const initialState: IFormAlert = {
  type: 'info',
  title: '',
  message: '',
  isVisible: false,
};

const formAlertSlice = createSlice({
  name: 'formAlert',
  initialState,
  reducers: {
    showFormAlert: (
      state,
      action: PayloadAction<{ type: IFormAlert['type']; title: string; message: string }>
    ) => {
      const { type, title, message } = action.payload;
      state.type = type;
      state.title = title;
      state.message = message;
      state.isVisible = true;
    },
    hideFormAlert: (state) => {
      state.isVisible = false;
    },
  },
});

export const { showFormAlert, hideFormAlert } = formAlertSlice.actions;
export default formAlertSlice.reducer;
